export const ROUTE_MAP: Record<string, Record<string, string>> = {
  // =====================
  // DASHBOARD
  // =====================
  DASHBOARD: {
    VISUALIZAR: '/app/home',
  },

  // =====================
  // CUENTAS
  // =====================
  CUENTAS: {
    VISUALIZAR: '/app/accounts',
    VER_CUENTAS: '/app/accounts',
    INGRESAR_CUENTAS_PENDIENTES: '/app/accounts',

    REMOVER_CUENTAS: '/app/remove-accounts',
    CUENTAS_REMOVIDAS: '/app/accounts-removed',

    VER_SOLICITUDES_CUENTAS: '/app/payments', // flujo externo
  },

  // =====================
  // PAGOS
  // =====================
  PAGOS: {
    VER_PAGOS_NIVEL1: '/app/payment-verification',
    VER_PAGOS_NIVEL2: '/app/payment-account-transfer',
    ACTUALIZAR_PAGOS_NIVEL2: '/app/payments',

    CONFIRMAR_PAGO_CUENTRA_PRINCIPAL: '/app/payment-account-transfer',
  },

  // =====================
  // TANDAS
  // =====================
  TANDAS: {
    VER_RED_TANDAS: '/app/tandas',
    CREAR_TANDAS: '/app/tandas',
    ACTUALIZAR_TANDAS: '/app/tandas',
    VER_DETALLES_TANDAS: '/app/tandas',

    ADMINISTRACION_TANDAS: '/app/administration-tandas',
  },

  // =====================
  // USUARIOS
  // =====================
  USUARIOS: {
    VISUALIZAR: '/app/users',
    CREAR: '/app/users',
    ACTUALIZAR: '/app/users',
    ASIGNAR_PERMISOS: '/app/users',
  },

  // =====================
  // CLIENTES
  // =====================
  CLIENTES: {
    VISUALIZAR: '/app/clients',
    CREAR: '/app/clients',
    ACTUALIZAR: '/app/clients',
  },

  // =====================
  // CONFIGURACIÓN
  // =====================
  CONFIGURACION: {
    VER_CONFIGURACION: '/app/configuration',
    VER_TERMINOS_CONDICIONES: '/app/configuration',
    CREAR_TERMINOS_CONDICIONES: '/app/configuration',
  },

  // =====================
  // CUENTAS BANCARIAS
  // =====================
  CUENTAS_BANCARIAS: {
    VISUALIZAR: '/app/bank-accounts',
  },
};
